import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { FgInspectionSamples } from "./fg-inspection-samples.entity";
@Entity('fgInspection')
export class FgInspection {
    @PrimaryGeneratedColumn('increment', {
        name: 'fgInspection_id',
    })
    fgInspectionId: number;

   
    @Column({
        type: 'int',
        nullable: false,
        name: 'sale_order_id'
    })
    saleOrderId: number;

    @Column({
        type: 'int',
        nullable: false,
        
        name: 'sale_order_item_id'
    })
    saleOrderItemId: number;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "lot_number"
    })
    lotNumber: string;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "section"
    })
    section: string;

    @Column({
        nullable: true,
        name: 'inspection_date',
    })
    date: Date;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(type => FgInspectionSamples, samples => samples.fgInspectionInfo, { cascade: true })
    samplesInfo: FgInspectionSamples[];
}